const initialState = {
  serviceDefinitionList: [],
  apiGuide: {}
};
const ApiGuideReducer = (state = initialState, action) => {
  if (action.type === 'SET_SERVICE_DEFINITION_LIST') {
    return { ...state, serviceDefinitionList: action.payload };
  }
  return state;
};

export default ApiGuideReducer;
